import { DateTimeInputWUT } from '@wix/form-fields/wut';

export default DateTimeInputWUT;
